import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiAnalyticsService } from '../../services/api-analytics.service';
import { DataService } from "../../services/data.service";
import { URL_EXT, URL_IMG} from '../../constants/general';

@Component({
  selector: 'app-autonomous-opening',
  templateUrl: './autonomous-opening.component.html',
  styleUrls: ['./autonomous-opening.component.scss'],
  host:{
    'class':'col forms-assisted-style d-flex align-items-center justify-content-center'
  }
})
export class AutonomousOpeningComponent implements OnInit {

  generalData:any;
  name:string='';
  url=URL_EXT;
  img=URL_IMG;
  from:string='';
  constructor(private router:Router,
              private data: DataService,
              private apiAnalytics :ApiAnalyticsService) 
  { 
    if( sessionStorage.getItem('general_data') ){
      this.generalData = JSON.parse( sessionStorage.getItem('general_data') );
      const long_name = this.generalData.cx_nombre.split(' ');
      this.name = long_name[0];
    } else {
      this.router.navigate(['/registro']);
    }
  }

  @HostListener('window:popstate', ['$event'])
  onPopState() {
    sessionStorage.clear();
    this.router.navigate(['/registro']);
  }

  ngOnInit(): void {
    this.from=this.data.fromValue;
    window.scrollTo(0, 0);
    this.data.setStep('opciones/autonomo-thank-you-page');
    this.apiAnalytics.fbQ('CompleteRegistration');
    this.setEventGA();
  }

  setEventGA(){
    if(this.from==='CEO'){
      this.apiAnalytics.gTag(
        `Thankyou_Autonomo_${this.generalData.cx_folio}`, 
        'Thankyou | Autonomo', 
        'Tres Pasos Bursanet',
        this.generalData.cx_folio);
    }
    
    this.apiAnalytics.gTag(
      `Thankyoupage | Autonomo`, 
      'Thankyou | Autonomo', 
      'Tres Pasos Bursanet',
      this.generalData.cx_folio);
  }

  gtagSocial(social_network) {
    this.apiAnalytics.gTag(`Thankyou | Autonomo | ${social_network}`, 'Thankyou | Autonomo', 'Tres Pasos Bursanet','1');
  }

}
